import axios from "axios";

/**
 * Fire-and-forget activity log for app navigation events.
 */
export const logActivity = ({
  eventType = "Open",
  eventCategory,
  eventDescription,
  moduleName,
  metadata = null,
}) => {
  const username = sessionStorage.getItem("username");
  const token = sessionStorage.getItem("s_id");

  if (!username || !token) return;

  axios
    .post(
      "/mashhad.api/ActivityLog/Log",
      {
        eventType,
        eventCategory,
        eventDescription,
        moduleName,
        metadata,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    .catch(() => {}); // fire-and-forget
};
